import axios from "axios";
import Vue from "vue";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

// Contador de solicitudes activas (para evitar ocultar el loader si hay múltiples requests en curso)
let requestCount = 0;

function showLoader() {
  if (requestCount === 0) {
    Vue.prototype.$loading(true);
  }
  requestCount++;
}

function hideLoader() {
  requestCount--;
  if (requestCount === 0) {
    Vue.prototype.$loading(false);
  }
}

// Interceptor para solicitudes
instance.interceptors.request.use(
  (config) => {
    showLoader();
    return config;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
instance.interceptors.response.use(
  (response) => {
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

export default instance;
